import UploadVideoModalComponent from "./UploadVideoModalComponent";

export default UploadVideoModalComponent;